import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { ExperiState, ExperiStateMap } from "API/navExperiment";

interface StatusProps {
    status: ExperiState;
}

export default function Status({ status }: StatusProps) {
    return (
        <span className={classNames(style.root, style[`state${status}`])}>
            {ExperiStateMap[status]}
        </span>
    );
}
